import TrimbleMaps from "@trimblemaps/trimblemaps-js";
import MapConstant from "./mapconstants";
import MapHelper from "./helper";
import appConstants from "../../../../appConstants";

/**
 * Reverse geocode coordinates to get address using Trimble Maps SDK
 * Only returns address when confidence level is "Exact" or "Good"
 * Reference: https://developer.trimblemaps.com/maps-sdk/guide/geocoding/#example-1
 */
const ReverseGeocoding = (location) => {
  if (location?.latitude == null || location?.longitude == null) {
    return Promise.resolve(null);
  }

  return new Promise((resolve) => {
    TrimbleMaps.Geocoder.reverseGeocode({
      lonLat: [location.longitude, location.latitude],
      region: MapConstant.regions[MapHelper.config.country],
      success: function(response) {
        const result = response?.[0];
        if (result?.Address && appConstants.ACCEPTABLE_CONFIDENCE_LEVELS.includes(result.ConfidenceLevel)) {
          resolve(result.Address);
        } else {
          resolve(null);
        }
      },
      failure: function(error) {
        console.error("Reverse geocode error:", error);
        resolve(null);
      }
    });
  });
};

export default ReverseGeocoding;